import ContactForm from "./contactForm"

export default function ClientContact({setContactOpen, imv}) {
    return (
        <section className="absolute flex justify-center items-center top-0 left-0 min-w-full min-h-full bg-[#0009] backdrop-blur-sm z-30">
            <ContactForm setContactOpen={setContactOpen} imv={imv} />
        </section>
    )
}